import { cn } from '@tripleten/cn';

export const cnMessageToast = cn('message-toast');
